import { cloneDeep } from 'lodash';
import Big from "big.js";

/** 定义格式化数类型常量 */
export const PARSE_WITH_UNIT_TYPES = {
  TVL: 'tvl', // 流动性
  CHG: 'chg', // 涨跌幅
  COUNT: 'count', // 普通数字
  VOL: 'vol', // 普通数字
  OUT_AMOUNT: 'out_amount', // 代币兑换输出数量
}

export const SUBSCRIPT_NUMBERS = {
    "0": "₀", "1": "₁", "2": "₂", "3": "₃", "4": "₄",
    "5": "₅", "6": "₆", "7": "₇", "8": "₈", "9": "₉"
};

export function getSystemTheme() {
  const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)'); // 是深色
  // console.log('isDarkTheme', isDarkTheme);
  if (isDarkTheme.matches) {
    // 是深色
    return 'dark';
  } else {
    // 不是深色
    return 'light';
  }
}

/** 设置显示模式 */
export function setMode(mode) {
  if (mode) {
    document.documentElement.setAttribute('theme', 'dark');
  } else {
    document.documentElement.removeAttribute('theme');
  }
}

export function changeURLArg(obj) {
  let queryObj = createQueryObj()
  queryObj = { ...queryObj, ...obj };

  const newQuery = Object.keys(queryObj)
    .filter((key) => queryObj[key])
    .map((key) => `${key}=${queryObj[key]}`)
    .join('&');

  if (newQuery) {
    history.replaceState('', '', `${location.pathname}?${newQuery}${location.hash}`);
  } else {
    history.replaceState('', '', `${location.pathname}${location.hash}`);
  }
}

export function createQueryObj() {
  const query = location.search.slice(1);
  let queryObj = {};
  if (query) {
    _.forEach(query.split('&'), item => {
      let tempArr = item.split('=');
      queryObj[tempArr[0]] = tempArr[1];
    });
  }
  return queryObj
}

export function setSuiAptosTokenProperty(token) {
  let cloneToken = cloneDeep(token)
  const isMoveAddress = cloneToken.network === 'APTOS' || cloneToken.network === 'SUI'
  if (isMoveAddress) {
    cloneToken.isMoveAddress = isMoveAddress
    cloneToken.moveAddress = cloneToken.address + '::' + cloneToken.bl_symbol
  }
  return cloneToken
}

export function getUTC() {
  let utc_type = '';
  // this.getTokenDetail();
  // 获取当前时区 时区偏差（time-zone offset）表示协调世界时（UTC）与本地时区之间的差值，单位为分钟。需要注意的是如果本地时区后于协调世界时，则该差值为正值，如果先于协调世界时则为负值。例如你所在时区为 UTC+10（澳大利亚东部标准时间），将会返回 -600。对于同一个时区，夏令时（Daylight Saving Time）将会改变这个值。
  let timezoneOffset = new Date().getTimezoneOffset() / 60;
  if (timezoneOffset <= 0) {
    timezoneOffset = '+' + Math.abs(timezoneOffset);
  } else {
    timezoneOffset = '-' + Math.abs(timezoneOffset);
  }
  utc_type = `UTC${timezoneOffset}`;
  // console.log('utc_type', utc_type);
  return utc_type;
}

export const CHG_MAP = {
  "UTC+0": '+0',
  "UTC+1": '+1',
  "UTC+2": '+2',
  "UTC+3": '+3',
  "UTC+4": '+4',
  "UTC+5": '+5',
  "UTC+6": '+6',
  "UTC+7": '+7',
  "UTC+8": '+8',
  "UTC+9": '+9',
  "UTC+10": '+10',
  "UTC+11": '+11',
  "UTC+12": '+12',
  "UTC-1": '-1',
  "UTC-2": '-2',
  "UTC-3": '-3',
  "UTC-4": '-4',
  "UTC-5": '-5',
  "UTC-6": '-6',
  "UTC-7": '-7',
  "UTC-8": '-8',
  "UTC-9": '-9',
  "UTC-10": '-10',
  "UTC-11": '-11',
  "UTC-12": '-12',
}

/** 
 * 格式化价格，价格使用向下舍入 
 * 价格：
 *   x>=10: 2位小数，末尾0不去
 *   1<x<10: 3位小数 ，末尾0不去
 *   <=1:4位有效小数，末尾0不去
 */
export function parsePrice(val) {
  const scientificNumber = val;  // 科学计数法表示的数
  const bigNumber = new Big(scientificNumber);
  const normalNumberString = bigNumber.toFixed();  // 将科学计数法转换为普通数
  val = Number(normalNumberString);
  try {
    let subscript = '';
    if (String(val).indexOf('e') !== -1) {
      const str = String(val);
      const index = str.indexOf('e');
      if (str.charAt(index + 1) !== '-') {
        return val;
      }
      const zeroCount = Number(str.substring(index + 2)) - 1;
      const efficientNumbers = str
        .substring(0, index)
        .split('.')
        .join('')
        .substring(0, 3);
      // subscript = zeroCount;
      subscript = String(zeroCount).replace(/\d/g, (d) => SUBSCRIPT_NUMBERS[d] || d);
      return `0.0${subscript}${efficientNumbers}`;
      // return `0.0{${zeroCount}}${efficientNumbers}`;
    } else if (val >= 10) {
      return new Big(val).toFixed(2);
    } else if (val < 10 && val > 1) {
      return new Big(val).toFixed(3);
    } else if (val === 1) {
      return new Big(val).toPrecision(4)
    }
    else if (val > 0) {
      const arr = val.toString().split('');
      const pointIndex = arr.indexOf('.');
      if (pointIndex >= 0) {
        let firstEfficientIndex = pointIndex;
        for (let i = pointIndex + 1; i < arr.length; i++) {
          if (arr[i] !== '0') {
            firstEfficientIndex = i;
            break;
          }
        }
        if (val < 1 && val >= 0.0001) {
          // return arr
          //   .slice(0, Math.min(firstEfficientIndex + 3, arr.length))
          //   .join('');
          // return truncateDecimals(val, 4)
          return new Big(val).toPrecision(4)
        } else {
          subscript = firstEfficientIndex - pointIndex - 1;
          subscript = String(subscript).replace(/\d/g, (d) => SUBSCRIPT_NUMBERS[d] || d);
          // console.log('subscript', subscript);
          return `0.0${subscript}${arr
          // return `0.0{${firstEfficientIndex - pointIndex - 1}}${arr
            .slice(
              firstEfficientIndex,
              Math.min(firstEfficientIndex + 4, arr.length)
            )
            .join('')}`;
        }
      }
    } else {
      if (val < 0 && val > -1) {
        // return val.toFixed(4);
        return truncateDecimals(val, 4);
      } else {
        // return val.toFixed(2);
        return truncateDecimals(val, 2);
      }
    }
  } catch (err) {
    console.log(err, val);
  }
}
/** 
 * 格式化价值 保留两位小数 小于 0.001 的数值显示为 0
 * @param {number | string} val 
 * @param {string} type tvl 流动性, chg 涨跌幅, count 正整数, vol 成交额
 */
export function parseWithUnit(val, type) {
  const scientificNumber = val;  // 科学计数法表示的数
  const bigNumber = new Big(scientificNumber);
  const normalNumberString = bigNumber.toFixed();  // 将科学计数法转换为普通数
  val = Number(normalNumberString);
  try {
    if (val >= 1e30) {
      return Math.round(val / 1e27) / 1000 + 'Q';
    }  else if (val < 1e30 && val >= 1e27) {
      return Math.round(val / 1e24) / 1000 + 'R';
    } else if (val < 1e27 && val >= 1e24) {
      return Math.round(val / 1e21) / 1000 + 'Y';
    } else if (val < 1e24 && val >= 1e21) {
      return Math.round(val / 1e18) / 1000 + 'Z';
    } else if (val < 1e21 && val >= 1e18) {
      return Math.round(val / 1e15) / 1000 + 'E';
    } else if (val < 1e18 && val >= 1e15) {
      return Math.round(val / 1e12) / 1000 + 'P';  
    } else if (val < 1e15 && val >= 1e12) {
      return Math.round(val / 1e9) / 1000 + 'T';
    } else if (val < 1e12 && val >= 1e9) {
      return Math.round(val / 1e6) / 1000 + 'B';
    } else if (val < 1e9 && val >= 1e6) {
      return Math.round(val / 10000) / 100 + 'M';
    } else if (val < 1e6 && val >= 1000) {
      return Math.round(val / 10) / 100 + 'K';
    } else if (val < 1000 && val >= 1) {
      if (type === PARSE_WITH_UNIT_TYPES.COUNT) {
        return truncateDecimals(val, 5);
      } else if (type === PARSE_WITH_UNIT_TYPES.VOL) {
        if (val < 10) {
          return truncateDecimals(val, 2);
        } else {
          return new Big(val).round(2).toNumber().toLocaleString();
        }
      } else if (type === PARSE_WITH_UNIT_TYPES.CHG) {
        return truncateDecimals(val, 1);
      } else if (type === PARSE_WITH_UNIT_TYPES.OUT_AMOUNT) { // 输出数量先定保留三位小数，后续优化需要根据代币价格来判断需要显示多少小数位
        return truncateDecimals(val, 3);
      } else {
        return val.toFixed(1);
      }
    } else if (val > 0) {
      if (type === PARSE_WITH_UNIT_TYPES.TVL) {
        return 0;
      } else if (type === PARSE_WITH_UNIT_TYPES.CHG) {
        return truncateDecimals(val, 2)
        // return val.toFixed(2)
      } else {
        if (val < 0.00001 && type === PARSE_WITH_UNIT_TYPES.COUNT) {
          return 0;
        } else if (type === PARSE_WITH_UNIT_TYPES.COUNT) {
          return truncateDecimals(val, 5);
        } else
        // TVL和成交额小于0.001的数值显示为0
        if (val < 0.001 && (type === PARSE_WITH_UNIT_TYPES.VOL)) {
          return 0;
        } else if (type === PARSE_WITH_UNIT_TYPES.VOL) {
          return truncateDecimals(val, 2);
        } else {
          return parsePrice(val)
        }
      }
    } else if (val < 0) {
      if (type === PARSE_WITH_UNIT_TYPES.CHG) {
        return truncateDecimals(val, 2)
        // return val.toFixed(2)
      }
    } else {
      return 0;
    }
  } catch (err) {
    console.log(err, val);
  }
}

/** 保留小数位不四舍五入
 * @num {number} - 需要处理的数字
 * @digits {number} - 保留的小数位数
 * @returnType {number} - 格式化后的数字类型 0: string 1: number
 */
export function truncateDecimals(num, digits, returnType = 1) {
  try {
    const scientificNumber = num; // 科学计数法表示的数
    const bigNumber = new Big(scientificNumber);
    let normalNumberString = bigNumber.round(digits); // 保留2位小数
    if (returnType === 0) {
      return new Big(normalNumberString).toString();
    } else {
      return new Big(normalNumberString).toNumber();;
    }
  } catch (error) {
    console.log(error);
  }
}

/** 加法 */
export function add(a, b, returnType = 'string') {
  try {
    if (returnType === 'number') {
      return new Big(a).plus(new Big(b)).toNumber();
    } else {
      return new Big(a).plus(new Big(b)).toString();
    }
  } catch (error) {
    console.log(error);
  }
}

/** 减法 */
export function subtract(a, b, returnType = 'string') {
  try {
    if (returnType === 'number') {
      return new Big(a).minus(new Big(b)).toNumber();
    } else {
      return new Big(a).minus(new Big(b)).toString();
    }
  } catch (error) {
    console.log(error);
  }
}

/** 乘法 */
export function multiply(a, b, returnType = 'string') {
  try {
    if (returnType === 'number') {
      return new Big(a).times(new Big(b)).toNumber();
    } else {
      return new Big(a).times(new Big(b)).toString();
    }
  } catch (error) {
    console.log(error);
  }
}

/** 除法 */
export function divide(a, b, returnType = 'string') {
  try {
    if (returnType === 'number') {
      return new Big(a).div(new Big(b)).toNumber();
    } else {
      return new Big(a).div(new Big(b)).toString();
    }
  } catch (e) {
    return 'Error: Division by zero';
  }
}

export function hiddenScrollBar(flag) {
  if (flag) {
    document.body.style.overflow = 'hidden'
  } else {
    document.body.style.overflow = 'auto'
  }
}

/** 根据 name 读取 cookie */
export function getCookie(name) {
  const re = new RegExp('(?:^|; )' + name + '=([^;]*)');
  const m = document.cookie.match(re);
  return m ? decodeURIComponent(m[1]) : null;
}
